import { render, staticRenderFns } from "./status-indicator.vue?vue&type=template&id=90f0f23c&scoped=true"
import script from "./status-indicator.vue?vue&type=script&lang=js"
export * from "./status-indicator.vue?vue&type=script&lang=js"
import style0 from "./status-indicator.vue?vue&type=style&index=0&id=90f0f23c&prod&lang=scss&scoped=true"
import style1 from "./status-indicator.vue?vue&type=style&index=1&id=90f0f23c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f0f23c",
  null
  
)

export default component.exports